<template>
    <div class="form-account form-confirm-code">
        <div class="form-account__welcome">
            <i class="fas fa-envelope-open-text"></i>
            <h5>You've got mail!</h5>
        </div>

        <h1>Check your email</h1>

        <p>We've just sent an email with a <strong>6 digit confirmation code</strong> to {{hostEmail}}.</p>
        <p>Please copy the code into the form below to continue.</p>

        <div>
            <input v-model="confirmationCode" ref="code" type="text" class="form-account__text" v-on:keyup="checkToConfirm()">
        </div>

        <div v-if="error" class="alert alert-danger" role="alert">
            {{error}}
        </div>

        <div v-show="waiting">
            <Spinner/>
        </div>

        <div v-show="!waiting" >
            Email sent at {{emailSent}}. Didn't receive it?
            <button v-on:click="resendConfirmEmail()" class="btn btn-secondary">Resend confirmation email</button>
        </div>
    </div>
</template>

<script>
    import dayjs from "dayjs"

    import { store, mutations } from '@/store.js'

    import Spinner from '../Spinner.vue'

    export default {
        name: "Step2ConfirmCode",
        components: {Spinner},
        props: {
            code: String,
            emailSent: String
        },
        data: function () {
            return {
                confirmationCode: "",
                waiting: false,
                error: null,
            }
        },
        computed: {
            hostEmail: function() {
                return store.hostEmail
            }
        },
        methods: {
            confirmEmail: function () {
                this.waiting = true;
                this.error = null;
                const body = {
                    code: this.confirmationCode
                };
                this.$http.post('/guest-management/v1/users/' + store.host.reference + "/confirm-email", body
                ).then(response => {
                    console.log(response);
                    this.waiting = false;
                    mutations.setHost(response.data);
                    this.$root.$emit("create-account-confirm-email");
                }).catch(error => {
                    this.waiting = false;
                    this.confirmationCode = "";
                    setTimeout(() => {
                        this.$refs.code.focus()
                    }, 500)
                    if (error.response) {
                        this.error = error.response.data.message
                    } else {
                        this.error = "Sorry, we can't seem to reach our servers! Please try again"
                    }
                })
            },
            resendConfirmEmail: function () {
                this.waiting = true;
                this.error = null;
                this.$http.post('/guest-management/v1/users/' + store.host.reference + "/resend-confirm-email"
                ).then(response => {
                    console.log(response);
                    this.waiting = false;
                    this.emailSent = dayjs().format('HH:mm');
                    setTimeout(() => {
                        this.$refs.code.focus()
                    }, 250);
                }).catch(error => {
                    this.waiting = false;
                    this.confirmationCode = "";
                    setTimeout(() => {
                        this.$refs.code.focus()
                    }, 500);
                    if (error.response) {
                        this.error = error.response.data.message
                    } else {
                        this.error = "Sorry, we can't seem to reach our servers! Please try again"
                    }
                });
            },
            checkToConfirm: function() {
                if (this.confirmationCode.length >= 6) {
                    if (this.confirmationCode.length > 6) {
                        this.confirmationCode = this.confirmationCode.substring(0, 6)
                    }
                    this.confirmEmail();
                }
            }
        },
        mounted() {
            if (this.code) {
                this.confirmationCode = this.code;
                setTimeout(() => {
                    this.checkToConfirm()
                }, 1000)
            }
            setTimeout(() => {
                this.$refs.code.focus()
            }, 500)
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/pages/create-account";
</style>